import React from 'react';

const Condition = ({ when, is, children }) => {
  return when === is ? children : null;
};

export default Condition;
